import { ScheduleGroup } from "@swivl-mono/types";
import { createContext, useContext } from "react";

import { UseLocationFmsCapabilitiesResult } from "./Hooks/useLocationFmsCapabilities";
import { UseScriptsInForceResult } from "./Hooks/useScriptsInForce";
import { UseSequenceConfigResult } from "./Hooks/useSequenceConfig";
import { SequencePageScope } from "./sequenceScope";

export interface SequencesV3ContextValue {
  scope: SequencePageScope;
  config: UseSequenceConfigResult;
  fms: UseLocationFmsCapabilitiesResult;
  /** The org's schedule groups, for the "Send hours" picker (decision 50). */
  scheduleGroups: ScheduleGroup[];
  /** The call scripts in force at this scope, for a day's "Starting script" (ENG-3403). */
  scripts: UseScriptsInForceResult;
  canEdit: boolean;
}

const SequencesV3Context = createContext<SequencesV3ContextValue | null>(null);

export const SequencesV3Provider = SequencesV3Context.Provider;

export function useSequencesV3Context(): SequencesV3ContextValue {
  const value = useContext(SequencesV3Context);
  if (!value) {
    throw new Error("useSequencesV3Context must be used inside SequencesV3View");
  }
  return value;
}
